<template>
  <v-dialog v-model="dialog" max-width="600">
    <template v-slot:activator="{ on, gwModal }">
      <v-btn
        x-large
        elevation="3"
        class="ma-2"
        color="primary"
        v-bind="gwModal"
        v-on="on"
        >Click Me</v-btn
      >
    </template>
    <v-card elevation="3" class="modal-card">
      <v-card-title>
        <h3>Project Overview</h3>
        <v-spacer></v-spacer>
        <v-btn icon @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <hr />
      </v-card-title>
      <div class="modal-img">
        <img
          src="@/assets/images/featured-projects/GripWorksCo.jpg"
          alt="SDP"
        />
      </div>
      <div class="project-info">
        <h1>GripWorks Colorado</h1>
        <p>
          Responsive website for GripWorks Colorado. Denver Colorado’s go-to
          source for grip and lighting services. They offer complete video and
          TV lighting packages to suit every project, any budget. They offer
          professional film lighting equipment, as well as Gaffers, Key Grips,
          and trained film technicians to get your set lit quickly and safely
          every time.
        </p>
        <ul class="details">
          <li><label>Client:</label>GripWorks Colorado</li>
          <li><label>Category:</label>Web Development</li>
          <li><label>Role:</label>Developer</li>
          <li>
            <label>Project URL:</label
            ><a target="_blank" href="http://www.gripworksco.com/"
              >GripWorksCO.com</a
            >
          </li>
        </ul>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
    };
  },
};
</script>

<style lang="scss">
</style>